<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1Statements",
  data: () => ({
    current: 0
  }),
  computed: {
    ...mapGetters("bahn1", ["statements"]),
    items() {
      const list =
        this.statements && Array.isArray(this.statements.Statement)
          ? this.statements.Statement
          : [];
      return list.filter(
        item =>
          item &&
          (item.Statement || item.VorUndNachname || item.Rolle || item.Bild)
      );
    }
  },
  watch: {
    "items.length"(length) {
      if (this.current > length - 1) this.current = 0;
    }
  },
  methods: {
    imageUrl(item) {
      return item.Bild
        ? this.$store.getters.getStrapiImageUrl(item.Bild)
        : require("@/assets/Profile_Placeholder.png");
    },
    prev() {
      const count = this.items.length;
      if (count <= 1) return;
      this.current = (this.current - 1 + count) % count;
    },
    next() {
      const count = this.items.length;
      if (count <= 1) return;
      this.current = (this.current + 1) % count;
    }
  }
};
</script>

<template>
  <div class="statements" v-if="items.length">
    <div class="statements-body">
      <div class="statements-viewport">
        <div
          class="statements-track"
          :style="{ transform: `translateX(-${current * 100}%)` }"
        >
          <div class="statement" v-for="(item, index) in items" :key="index">
            <img
              class="statement-image"
              :src="imageUrl(item)"
              :alt="item.VorUndNachname"
            />
            <div class="statement-body">
              <p class="statement-text">{{ item.Statement }}</p>
              <div class="statement-name">{{ item.VorUndNachname }}</div>
              <div class="statement-role">{{ item.Rolle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statements-nav">
      <button
        class="statements-button"
        type="button"
        aria-label="Zurück"
        @click="prev"
      >
        <v-icon class="arrow-icon" size="28">mdi-arrow-left</v-icon>
      </button>
      <button
        class="statements-button"
        type="button"
        aria-label="Weiter"
        @click="next"
      >
        <v-icon class="arrow-icon" size="28">mdi-arrow-right</v-icon>
      </button>
    </div>
  </div>
</template>

<style scoped>
.statements-body {
  padding: 0 24px;
}
.statements-viewport {
  overflow: hidden;
  width: 100%;
}
.statements-track {
  display: flex;
  transition: transform 0.3s ease;
}
.statement {
  flex: 0 0 100%;
  display: flex;
  align-items: flex-start;
}
.statement-image {
  flex: 0 0 200px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 56px;
}
.statement-body {
  flex: 1;
}
.statement-text {
  margin: 0 0 61px;
  font-size: 24px;
  letter-spacing: 0.48px;
}
.statement-name {
  font-size: 16px;
  font-family: "GeometriaMedium";
  letter-spacing: 0.32px;
  line-height: 1;
}
.statement-role {
  margin-top: 8px;
  font-size: 16px;
  letter-spacing: 0.32px;
  line-height: 1;
}
.statements-nav {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
}
.statements-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  justify-content: center;
}
.arrow-icon {
  color: #b40055;
}
@media (max-width: 599px) {
  .statement {
    flex-direction: column;
  }
  .statement-image {
    flex: 0 0 auto;
    margin-right: 0;
    margin-bottom: 16px;
  }
}
</style>
